import { h, Component } from "preact";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";

import { payClicked, pay } from "../../state/actions/orderActions";

import InputField from "../../components/fields/InputField";
import TextareaField from "../../components/fields/TextareaField";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";

import { required } from "../../utils/Validators";
import { scrollToErrors } from "../../utils/ScrollToErrors";

class PaymentInvoice extends Component {
  constructor() {
    super();

    this.purchase = this.purchase.bind(this);
  }

  purchase(values) {
    const { slug, order, pay, payClicked, event } = this.props;
    const orderId = order.data._id;
    const eventId = event.data._id;
    payClicked();
    pay(slug, orderId, "invoice", values, eventId);
  }

  render({ order, handleSubmit }) {
    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    const error = order.paymentRequest.error;
    const businessPurpose =
      order && order.data && order.data.businessPurpose
        ? order.data.businessPurpose
        : false;

    return (
      <div>
        {error ? <p class="text-error">{error}</p> : ""}
        {!order.timeExpired ? (
          <form onSubmit={handleSubmit(this.purchase)}>
            <p>
              Upon purchase you will be sent an invoice with payment
              instructions. Once payment is received your tickets and receipt
              will be sent over to you.
            </p>
            <Field
              label="Business Name"
              type="text"
              name="organisation"
              component={InputField}
            />
            {businessPurpose ? (
              <Field
                label="ABN"
                type="text"
                name="businessTaxId"
                component={InputField}
              />
            ) : null}
            <Field
              label="First Name"
              type="text"
              name="firstName"
              component={InputField}
              required={true}
              validate={required}
              autocomplete="given-name"
            />
            <Field
              label="Last Name"
              type="text"
              name="lastName"
              component={InputField}
              required={true}
              validate={required}
              autocomplete="family-name"
            />
            <Field
              label="Address"
              type="text"
              name="address"
              component={TextareaField}
              required={true}
              validate={required}
              autocomplete="address"
            />
            <ActionBar>
              <ActionButton
                disabled={
                  order.waitingToPay ||
                  order.paymentRequest.loading ||
                  order.timeExpired
                }
                loading={order.waitingToPay || order.paymentRequest.loading}
              >
                Purchase
              </ActionButton>
            </ActionBar>
          </form>
        ) : null}
      </div>
    );
  }
}

PaymentInvoice = reduxForm({
  form: "invoice",
  destroyOnUnmount: false,
  onSubmitFail: () => {
    scrollToErrors();
  }
})(PaymentInvoice);

export default connect(
  state => ({
    initialValues: {
      firstName: state.order.data.firstName,
      lastName: state.order.data.lastName,
      organisation: state.order.data.businessName,
      businessTaxId: state.order.data.businessTaxId
    },
    event: state.event,
    order: state.order,
    orderSummary: state.orderSummary
  }),
  {
    pay,
    payClicked
  }
)(PaymentInvoice);



// WEBPACK FOOTER //
// ./routes/payment/PaymentInvoice.js